<div class="container mx-auto mt-12 space-y-8">
  <div
    class="flex flex-col rounded-xl p-4 ring-1 ring-zinc-900/15 md:p-8 dark:ring-white/10"
  >
    <h2 class="pb-4 text-3xl text-zinc-900 dark:text-zinc-200">Photo Upload</h2>
    <p *ngIf="!addState">
      Please provide photos that are a minimum of 1 megabyte and above.
    </p>
  </div>
  <div>
    <button
      *ngIf="!addState"
      class="flex cursor-pointer justify-center rounded-lg bg-green-700 px-3 py-2 font-semibold text-green-100 outline-offset-2 transition hover:bg-green-600 active:bg-green-700 active:text-green-100/70 active:transition-none"
      (click)="change()"
    >
      <span class="pr-2">&#43;</span>Add Photo
    </button>
  </div>

  <form
    *ngIf="addState"
    [formGroup]="form"
    (submit)="onSaveImage()"
    class="flex flex-col gap-8 rounded-xl p-4 ring-1 ring-zinc-900/15 md:p-8 dark:ring-white/10"
  >
    <!-- Photo selection -->
    <div class="flex flex-col items-center justify-center gap-4">
      <div
        *ngIf="imagePreview !== '' && imagePreview && form.get('file')?.valid"
      >
        <img
          [src]="imagePreview"
          alt="Image previewer"
          [title]="form.value.title"
          class="max-h-[24rem]"
        />
      </div>
      <button
        class="flex cursor-pointer justify-center rounded-lg bg-zinc-800 px-3 py-2 font-semibold text-zinc-100 outline-offset-2 transition hover:bg-zinc-700 active:bg-zinc-800 active:text-zinc-100/70 active:transition-none"
        type="button"
        (click)="filePicker.click()"
      >
        <span class="pe-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="size-6"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
            />
          </svg>
        </span>
        Pick Image
      </button>
      <input
        type="file"
        #filePicker
        (change)="onImagePicked($event)"
        class="hidden"
      />
    </div>

    <!-- Photo details -->
    <div class="flex w-full justify-center">
      <div class="relative flex flex-col items-center gap-4 xl:w-2/3">
        <!-- Error message -->
        <div
          class="absolute -mt-5 text-cam-red"
          role="alert"
          *ngIf="error && !form.valid"
        >
          {{ error }}
          <button
            type="button"
            class=""
            data-dismiss="alert"
            aria-label="Close"
            (click)="onClose()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <!-- Questions -->
        <div
          class="flex w-full flex-col lg:flex-row lg:items-center lg:justify-between"
        >
          <label for="questions">
            What is the title of the photo you are uploading?
          </label>
          <div class="ms-4 flex flex-col self-start">
            <input
              id="title"
              formControlName="title"
              name="title"
              type="text"
              class="rounded-lg border px-3 py-1 shadow-md shadow-zinc-800/5 focus:border-cam-blue focus:ring-4 focus:ring-cam-blue/10 focus:outline-hidden"
              [class.border-red-500]="form.get('title')?.invalid && form.get('title')?.touched"
            />
            <span
              *ngIf="form.get('title')?.invalid && form.get('title')?.touched && form.get('title')?.hasError('required')"
              class="mt-1 text-sm text-cam-red"
            >
              Title is required
            </span>
          </div>
        </div>
        <div
          class="flex w-full flex-col lg:flex-row lg:items-center lg:justify-between"
        >
          <label for="radio"> Is this photo safe for the web? </label>
          <div class="flex gap-4 ps-4">
            <div>
              <input
                type="radio"
                name="isSafe"
                id="exampleRadios1"
                formControlName="isSafe"
                ngvalue="true"
                [value]="true"
                checked
              />
              <label class="form-check-label" for="exampleRadios1"> Yes </label>
            </div>
            <div>
              <input
                type="radio"
                formControlName="isSafe"
                name="isSafe"
                id="exampleRadios2"
                [value]="false"
              />
              <label class="form-check-label" for="exampleRadios2"> No </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Button group -->
    <div class="flex w-full justify-center gap-8">
      <button
        class="flex cursor-pointer justify-center rounded-lg bg-green-700 px-3 py-2 font-semibold text-green-100 outline-offset-2 transition hover:bg-green-600 active:bg-green-700 active:text-green-100/70 active:transition-none"
        type="submit"
      >
        Upload Photo
      </button>
      <button
        class="cursor-pointer justify-center rounded-lg bg-red-700 px-3 py-2 font-semibold text-white outline-offset-2 transition hover:bg-red-600 active:bg-red-700 active:text-red-100/70 active:transition-none"
        type="button"
        (click)="change()"
      >
        Cancel
      </button>
    </div>
  </form>

  <div *ngIf="isLoading">
    <app-loading-spinner></app-loading-spinner>
  </div>
</div>
